import { faArrowUpArrowDown } from '@fortawesome/pro-regular-svg-icons/faArrowUpArrowDown';
import { faArrowDown19 } from '@fortawesome/pro-solid-svg-icons/faArrowDown19';
import { faArrowDownAZ } from '@fortawesome/pro-solid-svg-icons/faArrowDownAZ';
import { faArrowUp19 } from '@fortawesome/pro-solid-svg-icons/faArrowUp19';
import { faArrowUpAZ } from '@fortawesome/pro-solid-svg-icons/faArrowUpAZ';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { theme } from 'antd';
import type { SortOrder } from 'antd/es/table/interface';

interface PosTableSortIconProps {
  sorted: SortOrder;
  type: 'string' | 'number';
}

const sortIcons = {
  ascend: {
    string: faArrowUpAZ,
    number: faArrowUp19,
  },
  descend: {
    string: faArrowDownAZ,
    number: faArrowDown19,
  },
};

export const PosTableSortIcon = ({ sorted, type }: PosTableSortIconProps) => {
  const { token } = theme.useToken();

  const isSorted = sorted === 'ascend' || sorted === 'descend';

  return (
    <FontAwesomeIcon
      icon={isSorted ? sortIcons[sorted][type] : faArrowUpArrowDown}
      color={isSorted ? token.colorPrimary : token.colorTextQuaternary}
    />
  );
};
